module.exports = __webpack_public_path__ + "5786eaad25d3ba2ae5c3c24a43227423.svg";